/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { AreaOfStudyEntity } from '@axiom/domain';
/**
 * Response projection of the AreaOfStudy entity. Extends AreaOfStudyEntity
 * (inherits `static key = 'AreaOfStudy'`), so this projection and the full
 * AreaOfStudy entity merge into the same normalized cache record.
 * dark-roast DTO: PatchAreaOfStudyResponseDto
 */
export class UpdateAreaOfStudyResponseEntity extends AreaOfStudyEntity {
  override isStem: boolean = false;
}